
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../router/all_routes';
import AOS from 'aos';

const Contact = () => {
    const routes = all_routes;

    useEffect(() => {
        AOS.init({ duration: 1200, once: true });
    }, []);

    return (
        <div className="main-wrapper">
             <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row align-items-center text-center">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title">Contactează-ne</h2>
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={routes.home}>Acasă</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Contact</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="contact-section">
                <div className="container">
                    <div className="contact-info-area">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 col-12 d-flex" data-aos="fade-up">
                                <div className="single-contact-info w-100">
                                    <span><i className="feather-phone-call"></i></span>
                                    <h6>Telefon</h6>
                                    <p><a href="tel:+40774555555">+40 774 555 555</a></p>
                                    <p className="text-muted text-sm">Luni-Vineri: 09:00 - 18:00</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12 d-flex" data-aos="fade-up" data-aos-delay="100">
                                <div className="single-contact-info w-100">
                                    <span><i className="feather-mail"></i></span>
                                    <h6>Email</h6>
                                    <p><a href="mailto:adcarshowroom@gmail.com">adcarshowroom@gmail.com</a></p>
                                    <p className="text-muted text-sm">Răspundem în maxim 24h</p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12 d-flex" data-aos="fade-up" data-aos-delay="200">
                                <div className="single-contact-info w-100">
                                    <span><i className="feather-map-pin"></i></span>
                                    <h6>Locație</h6>
                                    <p>București, România</p>
                                    <p className="text-muted text-sm">Vizită doar cu programare</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group-item" data-aos="fade-up" data-aos-delay="300">
                        <div className="contact-heading">
                            <h3>Trimite-ne un mesaj</h3>
                            <p>Ai o întrebare sau vrei să programezi o vizionare? Completează formularul de mai jos.</p>
                        </div>
                        <form>
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <div className="input-block">
                                        <label>Nume <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" placeholder="Numele tău" required />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="input-block">
                                        <label>Email <span className="text-danger">*</span></label>
                                        <input type="email" className="form-control" placeholder="Adresa ta de email" required />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="input-block">
                                        <label>Subiect</label>
                                        <input type="text" className="form-control" placeholder="Subiectul mesajului" />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="input-block">
                                        <label>Mesaj <span className="text-danger">*</span></label>
                                        <textarea className="form-control" placeholder="Mesajul tău..." rows={4} required></textarea>
                                    </div>
                                </div>
                                <div className="col-lg-12 text-center">
                                    <button className="btn btn-primary submit-btn" type="submit">Trimite Mesaj</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Contact;
